import { Wrench, Hammer, PaintBucket, Cog, Truck, Car, CheckCircle, ChevronRight } from "lucide-react";

// Default icons for workflow steps
const STEP_ICONS = {
  default: Wrench,
  expertise: Wrench,
  demontage: Wrench,
  redressage: Hammer,
  peinture: PaintBucket,
  preparation: PaintBucket,
  remontage: Cog,
  livraison: Truck,
  lavage: Car,
  controle: CheckCircle,
  entretien: Wrench,
  mecanique: Wrench,
};

function getStepIcon(stepName) {
  const name = stepName?.toLowerCase() || "";
  for (const [key, icon] of Object.entries(STEP_ICONS)) {
    if (name.includes(key)) return icon;
  }
  return STEP_ICONS.default;
}

export default function WorkflowStepper({ vehicle, workflowSteps }) {
  const steps = workflowSteps || [];
  
  const getCurrentIndex = () => {
    if (!vehicle || vehicle.workflow_step === "termine") return steps.length;
    const idx = steps.findIndex(s => s.name === vehicle.workflow_step);
    return idx >= 0 ? idx : 0;
  };

  const currentIdx = getCurrentIndex();

  if (steps.length === 0) {
    return <div className="text-slate-500 text-sm">Chargement du workflow...</div>;
  }

  return (
    <div className="flex items-center justify-between overflow-x-auto pb-2">
      {steps.map((step, idx) => {
        const Icon = getStepIcon(step.name);
        const done = idx < currentIdx;
        const active = idx === currentIdx;
        
        return (
          <div key={`${step.id || step.name}-${idx}`} className="flex items-center flex-1 min-w-0">
            <div className="flex flex-col items-center flex-1 min-w-[60px]">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
                done ? "bg-emerald-500 text-white" : 
                active ? "bg-red-600 text-white ring-4 ring-red-100" : 
                "bg-slate-200 text-slate-500"
              }`}>
                {done ? (
                  <CheckCircle className="h-5 w-5" />
                ) : (
                  <Icon className="h-5 w-5" />
                )}
              </div>
              <span className={`text-[10px] mt-1 text-center font-medium leading-tight ${
                active ? "text-red-600 font-bold" : done ? "text-emerald-600" : "text-slate-500"
              }`}>
                {step.label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <ChevronRight className={`h-4 w-4 flex-shrink-0 mx-0.5 ${
                idx < currentIdx ? "text-emerald-400" : "text-slate-300"
              }`} />
            )}
          </div>
        );
      })}
      {/* Terminé */}
      <div className="flex items-center min-w-0">
        <div className="flex flex-col items-center min-w-[60px]">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
            vehicle?.workflow_step === "termine" 
              ? "bg-emerald-500 text-white ring-4 ring-emerald-100" 
              : "bg-slate-200 text-slate-500"
          }`}>
            <CheckCircle className="h-5 w-5" />
          </div>
          <span className={`text-[10px] mt-1 text-center font-medium ${
            vehicle?.workflow_step === "termine" ? "text-emerald-600 font-bold" : "text-slate-500"
          }`}>
            Terminé
          </span>
        </div>
      </div>
    </div>
  );
}
